var _defs, _g, _rect, _g2, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #091430;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,2.1c0,0,0,.1,0,.2,0,0,0,0-.1,0s0,0,0,0l-.9-.9s0,0,0-.1,0,0,0-.1l.9-.9c0,0,.1,0,.2,0,0,0,0,.1,0,.2l-.8.8.8.8Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 1.3,
    y: 1.2,
    width: 7.6,
    height: 0.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon1",
    "data-name": "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,.6c0,0,0-.1,0-.2,0,0,0,0,.1,0s0,0,0,0l.9.9s0,0,0,.1,0,0,0,.1l-.9.9c0,0-.1,0-.2,0,0,0,0-.1,0-.2l.8-.8-.8-.8Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -1,
    y: 1.1,
    width: 2.5,
    height: 0.3,
    transform: "translate(1.5 1.1) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 8.6,
    y: 1.1,
    width: 2.5,
    height: 0.3,
    transform: "translate(11.1 -8.5) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.0b94bef22b6ff2db1bbf16c3516b13ab.svg";
export { ForwardRef as ReactComponent };